import * as yup from "yup";

export const alphaNumericProgramIdRegex = /^[a-zA-Z0-9]{26}$/;
export const numericProgramIdRegex = /^\d{6,8}$/;

export const getProgramIdValue = (entry: any): string => {
  const rawValue = entry?.programId ?? entry?.programID ?? "";
  return String(rawValue).trim();
};

export const hasValue = (value: string | number | null | undefined): boolean =>
  Boolean(String(value ?? "").trim());

export const normalizeMixCodes = (mixCodesParameters: any[] = []) =>
  mixCodesParameters.map((entry) => ({
    ...entry,
    programId: getProgramIdValue(entry),
    secret: (entry?.secret || "").trim(),
    uri: (entry?.uri || "").trim(),
  }));

const copyPromotionValidationSchema = yup
  .object()
  .test(
    "copy-promotion-mixcodes-validation",
    "Invalid MiX Codes data",
    function (values: any) {
      const root = (values || {}) as Record<string, any>;
      const mixCodesParameters = normalizeMixCodes(
        (root["secrets"]?.["mixCodesParameters"] as any[]) || []
      );
      const codeTypes = (root["tempParams"]?.["codeType"] as any[]) || [];

      for (let index = 0; index < mixCodesParameters.length; index++) {
        const entry = mixCodesParameters[index];
        const selectedCodeType = codeTypes[index];
        const hasCodeType = hasValue(selectedCodeType);
        const hasProgramId = hasValue(entry.programId);

        if (hasCodeType && !hasProgramId) {
          return this.createError({
            path: "secrets.mixCodesParameters",
            message: "If functionality is applied, mixcodes details are required",
          });
        }

        if (
          hasProgramId &&
          !(
            alphaNumericProgramIdRegex.test(entry.programId) ||
            numericProgramIdRegex.test(entry.programId)
          )
        ) {
          return this.createError({
            path: "secrets.mixCodesParameters",
            message:
              "Program Id must be alphanumeric characters of 26 or numeric of 6-8",
          });
        }

        if (hasProgramId && !hasCodeType) {
          return this.createError({
            path: "secrets.mixCodesParameters",
            message: "If functionality is applied, mixcodes details are required",
          });
        }

        if (hasValue(entry.secret) && (!hasProgramId || !hasCodeType)) {
          return this.createError({
            path: "secrets.mixCodesParameters",
            message:
              "If functionality is applied, mixcodes details are required",
          });
        }

        if ((hasProgramId || hasCodeType) && !hasValue(entry.secret)) {
          return this.createError({
            path: "secrets.mixCodesParameters",
            message:
              "If functionality is applied, mixcodes details are required",
          });
        }
      }

      return true;
    }
  );

export { copyPromotionValidationSchema };
